<template>
  <v-form v-model="valid" @submit.prevent="$emit('submitedform', user)">
    <v-container p-0>
      <v-row class="my-0">
        <v-col class="pt-0 pb-0 my-0" cols="12">
          <div class="subtitle-1">{{ $t('LoggedArea.Settings.InputsSettings.subtitle') }}</div>

          <v-text-field
            color="purple darken-4"
            style="margin-top: 0px;"
            v-model="user.name"
            :rules="nameRules"
            :counter="25"
            required
            :hint="$t('LoggedArea.Settings.InputsSettings.hint')"
          >
            <template v-slot:label>
              <span
                style="font-size: 0.875rem;font-weight: 300;color: #282f37;"
              >{{ $t('LoggedArea.Settings.InputsSettings.profileName') }}</span>
            </template>
          </v-text-field>

          <v-text-field
            color="purple darken-4"
            style="margin-top: 0px;"
            v-model="user.userName"
            :rules="userNameRules"
            :counter="25"
            required
            :hint="$t('LoggedArea.Settings.InputsSettings.hint')"
          >
            <template v-slot:label>
              <span
                style="font-size: 0.875rem;font-weight: 300;color: #282f37;"
              >{{ $t('LoggedArea.Settings.InputsSettings.userName') }}</span>
            </template>
          </v-text-field>

          <!-- Selecting the artist profile type-->
          <Specialty @changespecialty="sendSpecialtyToStore($event)" :specialties="specialties" />

          <SpecialtyPopUp
            @changespecialty="user.specialty=$event"
            @addSpecialty="addSpecialty($event)"
            :changespecialty="changespecialty"
            :lastSpecialty="lastSpecialty"
          />

          <div class="d-flex align-center btn-logged-area">
            <v-btn
              type="submit"
              m-5
              style="outline: none"
              class="font-weight-light text-capitalize"
              @click="analyticSaveUserForm"
              rounded
              color="purple darken-4"
              dark
            >{{ $t('LoggedArea.Settings.InputsSettings.save') }}</v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import { analytics } from "@/config/firebaseConfig";
import SpecialtyPopUp from "./SpecialtyPopUp";
import Specialty from "./Specialty";

export default {
  props: ["user", "specialties", "lastSpecialty"],
  components: { SpecialtyPopUp, Specialty },
  data() {
    return {
      valid: true,
      nameRules: [
        (v) =>
          !!v ||
          this.$t("LoggedArea.Settings.InputsSettings.profileNameRequired"),
        (v) =>
          (v && v.length <= 25) ||
          this.$t("LoggedArea.Settings.InputsSettings.profileNameLength"),
      ],
      userNameRules: [
        (v) =>
          !!v || this.$t("LoggedArea.Settings.InputsSettings.userNameRequired"),
        (v) =>
          (v && v.length <= 25) ||
          this.$t("LoggedArea.Settings.InputsSettings.userNameLength"),
      ],
      selectedSpecialty: "",
      changespecialty: "",
    };
  },
  methods: {
    analyticSaveUserForm() {
      analytics.logEvent("Btn_SavUsrInf");
    },
    addSpecialty(specialty) {
      this.changeSpecialty = this.specialties.pop();
      this.specialties.push(specialty);
    },
    sendSpecialtyToStore(specialty) {
      this.user.specialty = specialty;
    },
  },
};
</script>

<style>
</style>